const ValidationMessage = {
    emailRequired: "Email is required",
    emailInvalid: "Please enter a valid email address.",
    passwordRequired: "Password is required",
    firstNameRequired: "First name is required",
    lastNameRequired: "Last name is required",
    roleRequired: "Role is required",
    designationRequired: "Designation is required",
    statusRequired: "Status is required",
    two_factor_authentication: "Authentication Method is required",
    locationRequired: "Location is required",
    storeRequired: "Store is required",
    employeePortfolioRequired: "Employee portfolio is required"
};
export default ValidationMessage;
